import React from 'react';
import PriceUS from './price/PriceUS';
import PriceMX from './price/PriceMX';

const Prices = (props) => (
  <div className="pcb-price-section">
    <div className="price-matrices">
      <PriceUS {...props} />
      <PriceMX {...props} />
    </div>
  </div>
);

export default Prices;
